export enum ToastStatus {
	GENERIC = 'generic',
	SUCCESS = 'success',
	ERROR = 'error',
}
